import { render, staticRenderFns } from "./SharedRecordsTempAccountForm.vue?vue&type=template&id=0bd1a2d6&scoped=true"
import script from "./SharedRecordsTempAccountForm.vue?vue&type=script&lang=js"
export * from "./SharedRecordsTempAccountForm.vue?vue&type=script&lang=js"
import style0 from "./SharedRecordsTempAccountForm.vue?vue&type=style&index=0&id=0bd1a2d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1a2d6",
  null
  
)

export default component.exports